<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="submit" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.file.$invalid" :vm-active="isVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.file.$invalid },]")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-select(:placeholder='$t("change_orders.type_placeholder")' :danger="$v.form.type.$invalid && $v.form.type.$model" :danger-text="$t('validation.required', { attribute: $t('change_orders.type') })" v-model="form.type" :label='$t("change_orders.type")')
            vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in types")
        vm-col(vm-justify="center", vm-align="center", vm-w=12)
          b-form-group
            vm-input(autofocus :placeholder='$t("change_orders.description_placeholder")' :danger="$v.form.description.$invalid && $v.form.description.$model" :danger-text="$t('validation.required', { attribute: $t('change_orders.description') })" v-model="form.description" :label='$t("change_orders.description")')
        vm-col(vm-justify="center", vm-align="center", vm-w=12)
          b-form-group
            vm-input(autofocus :placeholder='$t("change_orders.amount_placeholder")' :danger="$v.form.amount.$invalid && $v.form.amount.$model" :danger-text="$t('validation.required', { attribute: $t('change_orders.amount') })" v-model="form.amount" :label='$t("change_orders.amount")' type="currency")
        vm-col(vm-justify="center", vm-align="center", vm-w=12)
            b-form-group
                input(@change="setFile" text="$t(strings.purchase_order)" type="file")
</template>
<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
import Uploader from 'vux-uploader-component'
const { mapGetters, mapActions } = createNamespacedHelpers('Projects')

export default {
  name: 'ModalChangeOrders',
  components: {
    Uploader
  },
  mixins: [ModalMixin1],
  props: {
    projectId: {
      default: null,
      type: Number
    },
    isVisible: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    form: {
      type: '',
      description: '',
      amount: ''
    },
    file: null,
    types: [
      {
        value: 1,
        text: 'Adicional'
      },
      {
        value: 2,
        text: 'Deductiva'
      }
    ]
  }),
  validations () {
    return {
      form: {
        type: {
          required
        },
        description: {
          required
        },
        amount: {
          required
        }
      },
      file: {
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'catalog', 'testimonials'])
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setModalVisible',
      'loadCatalog'
    ]),
    setFile (event) {
      this.file = event.target.files[0]
    },
    resetForm () {
      this.form = {
        type: null,
        description: null,
        amount: null
      }
    },
    close () {
      this.$emit('closeModal')
      this.resetForm()
    },
    submit () {
      this.$emit('submit', this.form, this.file)
      this.close()
    }
  }
}
</script>
<style lang="scss">
.image_section {
  padding-left: 0.5rem;
  -webkit-box-shadow: inset -33px -33px 3px -30px rgba(3,52,4,0.06);
  box-shadow: inset -33px -33px 3px -30px rgba(3,52,4,0.06);
}
.image_indicator {
  margin: 1rem 0 0 76%;
  text-align: center;
  padding: .4rem;
  width: 2rem;
  height: 2rem;
  border-top: 1px solid rgba(var(--primary),1);
  border-right: 1px solid rgba(var(--primary),1);
  border-bottom: 1px solid rgba(var(--primary),1);
  border-left: 1px solid rgba(var(--primary),1);
  border-radius: 100%;
}
.images_container {
  padding-left: 1.3rem;
}
</style>
